@if (showEmptyLegendMessage) {
  @if (emptyLegendMessage) {
    <span class="ggc-dl-empty-legend-message">
      {{ emptyLegendMessage }}
    </span>
  } @else {
    <span class="ggc-dl-empty-legend-message"> Geen legenda beschikbaar </span>
  }
}
